import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksStaffGroups(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		options
	)
}
function _getRegulationsStagesPlanWorksStaffGroupPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksStaffGrouptPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksStaffGroup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
		options
	)
}

function _getRegulationsStagesPlanWorksStaffGroup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
		options
	)
}

function _patchRegulationsStagesPlanWorksStaffGroup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
		options
	)
}

function _putRegulationsStagesPlanWorksStaffGroup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
		options
	)
}

function _deleteRegulationsStagesPlanWorksStaffGroup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]: _getRegulationsStagesPlanWorksStaffGroups,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_PREVIEW]: _getRegulationsStagesPlanWorksStaffGroupPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_POPUP]: _getRegulationsStagesPlanWorksStaffGrouptPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: _createRegulationsStagesPlanWorksStaffGroup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: _getRegulationsStagesPlanWorksStaffGroup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: _patchRegulationsStagesPlanWorksStaffGroup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: _putRegulationsStagesPlanWorksStaffGroup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: _deleteRegulationsStagesPlanWorksStaffGroup,
}
